




































import { Component, Vue, Watch } from 'vue-property-decorator';
import { accountSettingsService } from '@/services/AccountSettingsService';
import { formatDistance } from 'date-fns';
import { UAParser } from 'ua-parser-js';
import { tokenService } from '@/services/TokenService';
import { pl, enGB } from 'date-fns/locale';

@Component({ props: ['language'] })
export default class ActiveSessions extends Vue {
  activeSessions: any = {};
  isLoading: boolean = false;

  @Watch('$props.language', { immediate: true })
  onLangChange() {
    return this.$props.language;
  }

  mounted() {
    this.getActiveSessions();
  }
  getActiveSessions() {
    const tokenData = tokenService.getTokenPayload();
    accountSettingsService
      .getActiveSessions()
      .then((data: any) => {
        data.sessions.sort((a: any, b: any) => {
          return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
        });
        this.activeSessions = data.sessions.map((item: any) => {
          item.os = this.getOsName(item.user_agent);
          item.browser = this.getBrowserName(item.user_agent);
          switch (item.os) {
            case 'Windows':
              item.img = 'windows.png';
              break;
            case 'Mac OS':
              item.img = 'mac-os.svg';
              break;
            case 'Android':
              item.img = 'android.svg';
              break;
            case 'Blackberry':
              item.img = 'blackberry.svg';
              break;
            case 'Tizen':
              item.img = 'tizen.png';
              break;
            case 'Mint':
              item.img = 'linux mint.png';
              break;
            case 'Ubuntu':
              item.img = 'ubuntu.png';
              break;
            case 'Debian':
              item.img = 'debian.png';
              break;
            case 'SUSE':
              item.img = 'opensuse.png';
              break;
            case 'Fedora':
              item.img = 'fedora.png';
              break;
            case 'Arch':
              item.img = 'archlinux.png';
              break;
            case 'CentOS':
              item.img = 'centos.png';
              break;
            default:
              item.img = 'desktop_icon.png';
              break;
          }
          item.isCurrentSession = tokenData.jti === item.jti;
          return item;
        });
      })
      .catch(() => {});
  }

  getOsName(uAgent: string) {
    if (!uAgent) {
      return '-';
    }
    const parser = new UAParser();
    parser.setUA(uAgent);
    const result = parser.getResult();
    return result && result.os && result.os.name ? result.os.name : this.$t('unknownDevice');
  }
  getBrowserName(uAgent: string) {
    if (!uAgent) {
      return '-';
    }
    const parser = new UAParser();
    parser.setUA(uAgent);
    const result = parser.getResult();
    return result && result.browser && result.browser.name && result.browser.major
      ? `${result.browser.name} ${result.browser.major}`
      : '-';
  }
  reformatDate(date: string) {
    const parts = date.split(' ');
    return `${parts[0]}T${parts[1]}${parts[2]}`;
  }
  descriptiveDateFormat(date: string) {
    return formatDistance(new Date(this.reformatDate(date)), new Date(), {
      addSuffix: true,
      locale: this.$props.language === 'pl' ? pl : enGB,
    });
  }
  expireSession(sessionId: number) {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    accountSettingsService
      .sessionSignOut(sessionId)
      .then(() => {
        this.isLoading = false;
        this.getActiveSessions();
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
